module.exports = __webpack_public_path__ + "media/images/application/template/placeholder-e2b24ca8fdd245245389afb78bf3dd93.png";